export default class WebSocketMessageRequest {
    constructor(
        private messageType: string,
        private userType: string,
        private name: string,
        private username: string,
        private onlySave: boolean,
        private topicId : string,
        private content ?: string,
        private listener ?: string,
        private messageAttempt ?: number
    ){} 
}